import { ISimpleTableRow } from "@asup/simple-table";
import { TlfTag } from "functions/api/tlfItem/TlfItemIndexReadDto";

/**
 * Searches TLF templates by text matching AZSOL ID, title, TOC label, or tag values.
 *
 * @param row - Table row to search
 * @param searchText - Search text to match
 */
export const searchTemplatesWithText = (row: ISimpleTableRow, searchText: string) => {
  const needle = searchText.toLowerCase().trim();
  return (
    `${row.azsolIdVersion ?? ""}`.toLowerCase().includes(needle) ||
    `${row.title ?? ""}`.toLowerCase().includes(needle) ||
    `${row.tocLabel ?? ""}`.toLowerCase().includes(needle) ||
    (Array.isArray(row.tlfTags) &&
      (row.tlfTags as TlfTag[]).some((tag) => tag.tagValue.toLowerCase().includes(needle)))
  );
};
